import { client } from './api';

const list = () => {
  return client('gateway/customers');
};

export { list };
